
import Vue from "vue";
import { mapActions } from "vuex";

export default Vue.extend({
  name: "SearchForm",
  data: () => {
    return {
      valid: false,
      isEmptyFields: true,
      firstName: "",
      lastName: "",
      email: "",
      date: [],
      jobID: "",
      modal: false,
      emailRules: [] as any
    };
  },
  computed: {
    allowSubmitForm() {
      return this.firstName.length +
        this.lastName.length +
        this.email.length +
        this.jobID.toString().length +
        this.date.length >
        0 && this.valid
        ? true
        : false;
    },
    dateRangeText: {
      get() {
        return [...this.date].sort().join(" ~ ");
      },
      set(newValue) {
        return newValue;
      }
    }
  },
  methods: {
    ...mapActions(["getPaymentIntegrities", "getUnresolvedPayments"]),
    saveDate(date: Array<string>): void {
      (this.$refs.dialog as HTMLFormElement).save(date.sort());
    },
    clearValidationEmail(string: string): void {
      if (string.length === 0) {
        (this.$refs.form as HTMLFormElement).resetValidation();
      }
    },
    clearDate(): void {
      (this.$refs.dialog as HTMLFormElement).save([]);
    },
    submitForm(): void {
      if (this.email.length > 0) {
        this.emailRules = [
          (v: string) => /.+@.+/.test(v) || "E-mail no correct"
        ];
      }
      setTimeout(async () => {
        if (
          (this.$refs.form as HTMLFormElement).validate() &&
          this.checkIfMultiple()
        ) {
          this.$emit("error", "");
          this.$emit("loading");
          try {
            // Build array of search conditions from filled fields
            const conditions: Array<{
              column: string;
              value: string | string[];
            }> = [];

            if (this.firstName) {
              conditions.push({
                column: "h.firstName",
                value: this.firstName
              });
            }
            if (this.lastName) {
              conditions.push({
                column: "h.lastName",
                value: this.lastName
              });
            }
            if (this.email) {
              conditions.push({
                column: "u.email",
                value: this.email
              });
            }
            if (this.date.length) {
              conditions.push({
                column: "j.startDate",
                value: this.date
              });
            }
            if (this.jobID) {
              conditions.push({
                column: "j.id",
                value: this.jobID.toString()
              });
            }

            const data = await this.getPaymentIntegrities({
              conditions: conditions
            });
            if (data.length) {
              (this.$refs.form as HTMLFormElement).reset();
              this.reset();
              this.$emit("next");
            } else {
              this.$emit(
                "error",
                "Nothing was found for your query, please try again."
              );
            }
          } catch (err) {
            this.$emit("error", "Something wrong, please try again.");
          }
        } else {
          this.$emit("error", "Please fill in one field to search");
        }
      });
    },
    reset(): void {
      this.firstName = this.lastName = this.email = this.jobID = "";
      this.date = [];
      this.$emit("reset");
    },
    checkIfMultiple(): boolean {
      let counter = 0;
      [this.firstName, this.lastName, this.email, this.jobID, this.date].map(
        i => i.length !== 0 && counter++
      );
      // Return true if at least one field is filled (allow multiple fields)
      return counter >= 1 ? true : false;
    },
    async unresolvedPayments(): Promise<void> {
      this.$emit("error", "");
      this.$emit("loading");
      try {
        const data = await this.getUnresolvedPayments();
        if (data.length) {
          (this.$refs.form as HTMLFormElement).reset();
          this.reset();
          this.$emit("next");
        } else {
          this.$emit(
            "error",
            "Nothing was found for your query, please try again."
          );
        }
      } catch (err) {
        this.$emit("error", "Something wrong, please try again.");
      }
    }
  }
});
